import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository, type AssignDriverParams } from '../infra/ShipmentRepository'

export type AssignDriverDependencies = {
  repository: ShipmentRepository
}

export function assignDriverFactory({ repository }: AssignDriverDependencies) {
  return async function assignDriver({ driverUUID, shipmentUUID, config }: AssignDriverParams) {
    try {
      return await repository.assignDriverToShipment({ driverUUID, shipmentUUID, config })
    } catch (error) {
      throw new Error('Failed to assign the driver', { cause: error as Error })
    }
  }
}

export function assignDriverToShipment({ driverUUID, shipmentUUID, config }: AssignDriverParams) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const assignDriver = assignDriverFactory({ repository })

  return assignDriver({ driverUUID, shipmentUUID, config })
}
